export const ELLIPSIS = 'ellipsis' as const;

export type PaginationSlot = number | typeof ELLIPSIS;

/**
 * Page numbers to render, with gaps collapsed to an ellipsis. Always shows the
 * first and last page plus `siblings` either side of the current one, and keeps
 * the slot count stable so the control does not resize as you page through.
 */
export function paginationRange(
  currentPage: number,
  pageCount: number,
  siblings = 1,
): PaginationSlot[] {
  // first + last + current + 2 ellipses + siblings either side
  const maxSlots = siblings * 2 + 5;
  if (pageCount <= maxSlots) {
    return Array.from({ length: pageCount }, (_, index) => index + 1);
  }

  const left = Math.max(currentPage - siblings, 1);
  const right = Math.min(currentPage + siblings, pageCount);
  const showLeftEllipsis = left > 2;
  const showRightEllipsis = right < pageCount - 1;

  if (!showLeftEllipsis && showRightEllipsis) {
    const count = siblings * 2 + 3;
    return [...Array.from({ length: count }, (_, i) => i + 1), ELLIPSIS, pageCount];
  }

  if (showLeftEllipsis && !showRightEllipsis) {
    const count = siblings * 2 + 3;
    return [1, ELLIPSIS, ...Array.from({ length: count }, (_, i) => pageCount - count + 1 + i)];
  }

  return [
    1,
    ELLIPSIS,
    ...Array.from({ length: right - left + 1 }, (_, i) => left + i),
    ELLIPSIS,
    pageCount,
  ];
}
